<template>
  <div class="ascii-background" aria-hidden="true">
    <pre>{{ art }}</pre>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

const art = [
  '           r#####5                    i#####3         ',
  '           X@@@@@H                    s@@@@@G         ',
  '           s#####3                    s@@@@@H         ',
  '                               ..     s@@@@@H         ',
  '           iMMMMMA        ,XhG#99#Ghs.r@@@@@H         ',
  '           X@@@@@H      ,3B@@@@@@@@@@9H@@@@@H         ',
  '           X@@@@@M     ;9@@@@@9hXsX5G@@@@@@@H         ',
  '           X@@@@@M    .#@@@@@M,      s&@@@@@H         ',
  '           X@@@@@M    r@@@@@9.        3@@@@@H         ',
  '           X@@@@@M    A@@@@@H         r@@@@@H         ',
  '           X@@@@@M    A@@@@@S         s@@@@@H         ',
  '           X@@@@@M    :&@@@@&;        G@@@@@H         ',
  '           X@@@@@M     3@@@@@9X.    ;H@@@@@@H         ',
  '           X@@@@@M      5&@@@@@9GHH#@@&&@@@@H         ',
  '           X@@@@@M       ;hB@@@@@@@@9h;9@@@@G         ',
  '           X@@@@@M         ,rA3hh3Ai.  rXXXXi         ',
  '        ..,M@@@@@3                                    ',
  '       599B@@@@@@s                                    ',
  '      ,B@@@@@@@&3                                     ',
  '      :MGS#SGM2;                                      '
].join('\n')

export default defineComponent({
  name: 'AsciiBackground',

  setup() {
    return { art }
  }
})
</script>

<style scoped>
.ascii-background {
  position: fixed;
  inset: 0;
  z-index: -1;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 20vh;
  pointer-events: none;
  overflow: hidden;
}
.ascii-background pre {
  color: var(--green-color);
  opacity: 0.45;
  font-family: 'Anonymous Pro', monospace;
  font-size: clamp(7px, 2.2vmin, 17px);
  line-height: 1em;
  letter-spacing: 0;
  white-space: pre;
  margin: 0;
  user-select: none;
}
</style>
